import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './index.css';
import { INeighbourhoodSchema } from '../../../types';
import { Slider } from '../slider';

export interface IGalleryProps {
  data: INeighbourhoodSchema[] | void;
  currentSlide: number;

  onClose(): void;
  changeSlide(index: number): void;
}

export class Gallery extends React.Component<IGalleryProps> {
  private slider: Slider | null;

  public UNSAFE_componentWillMount() {
    document.addEventListener('keydown', this.onKeydownHandler, true);
    document.body.style.overflowY = 'hidden';
  }

  public componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeydownHandler, true);
    document.body.style.overflowY = 'visible';
  }

  public render() {
    const { data } = this.props;

    if (!data) {
      return <div />;
    }

    return (
      <div {...mergeStyles(styles['overlay'])}>
        <div className="cg-container-fluid-s">
          <div {...mergeStyles('cg-row', styles['date'])}>
            <button type="button" className={styles['close']} onClick={this.onClose} />
          </div>
          <Slider
            ref={sl => {
              this.slider = sl;
            }}
            slides={data}
            currentSlide={this.props.currentSlide}
          />
        </div>
      </div>
    );
  }

  private onClose = () => {
    document.removeEventListener('keydown', this.onKeydownHandler, true);
    this.props.onClose();
  };

  private onKeydownHandler = (e: KeyboardEvent) => {
    if (!this.slider) {
      return;
    }
    switch (e.keyCode) {
      case 27:
        e.preventDefault();
        e.stopPropagation();

        return this.onClose();
      case 37:
        e.preventDefault();
        e.stopPropagation();

        return this.slider.prev();
      case 39:
        e.preventDefault();
        e.stopPropagation();

        return this.slider.next();
      default:
        return;
    }
  };
}
